import type React from 'react';
import JobAppliancesTable from 'src/components/jobs/job-appliance-table';
import { useAppSelector } from 'src/hooks/redux-hooks';

const HvacUnitInfo: React.FC = () => {
  const locationAppliances = useAppSelector(
    (state) => state?.jobDetails?.data?.location_appliances,
  );
  const isHvacUpdatesApplicable = useAppSelector(
    (state) => state?.jobDetails?.data?.is_hvac_updates_applicable,
  );
  const serviceCategory = useAppSelector(
    (state) => state?.jobDetails?.data?.service_category,
  ) as Record<string, unknown> | undefined;

  return (
    <JobAppliancesTable
      serviceCategory={serviceCategory?.label as string}
      isHvacUpdatesApplicable={isHvacUpdatesApplicable as boolean | undefined}
      dataSource={locationAppliances as Record<string, unknown>[] | undefined}
      page="slide-out"
      className="unit-condition-report-table"
      isFromSlideOut
    />
  );
};

export default HvacUnitInfo;
